import type { AiKissQualityId } from "@marketing/ai-kiss/config/ai-kiss-preset";
import { buildR2AssetsImageUrl } from "@saas/shared/lib/image-url-builder";

export interface AiFrenchKissShowcaseClip {
	id: string;
	title: string;
	description: string;
	quality?: AiKissQualityId;
	template?: "french";
	orientation: "landscape" | "portrait";
	onSite: boolean;
	duration: number;
	videoUrl: string;
	previewVideoUrl: string;
	poster: string;
	hasAudio: boolean;
	inputImages?: string[];
	source?: string;
}

const R2_BASE = "home/showcase/ai-french-kiss";
const externalVideo = buildR2AssetsImageUrl(
	`${R2_BASE}/clips/ext-couple-720p.mp4`,
);

export const aiFrenchKissShowcaseClips: AiFrenchKissShowcaseClip[] = [
	{
		id: "ext-couple",
		title: "French Kiss from a Couple Photo",
		description:
			"Two partners turn toward each other and share a slow French kiss in a close-up scene.",
		orientation: "portrait",
		onSite: false,
		duration: 5,
		videoUrl: externalVideo,
		previewVideoUrl: externalVideo,
		poster: buildR2AssetsImageUrl(`${R2_BASE}/posters/ext-couple-720p.jpg`),
		hasAudio: false,
		source: "https://cliptrend.ai/ai-video-effects/french-kiss",
	},
	{
		id: "french-couple",
		title: "A Slow French Kiss at Home",
		description:
			"Made in this tool with Seedance 2.0 Mini at HD 720p: a fictional couple lean closer and share a slow French kiss.",
		quality: "hd",
		template: "french",
		orientation: "portrait",
		onSite: true,
		duration: 5,
		videoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/french-couple-720p.mp4`,
		),
		previewVideoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/french-couple-720p.mp4`,
		),
		poster: buildR2AssetsImageUrl(
			`${R2_BASE}/posters/french-couple-720p.jpg`,
		),
		hasAudio: true,
		inputImages: [buildR2AssetsImageUrl(`${R2_BASE}/refs/couple-2k.png`)],
	},
];

export const AI_FRENCH_KISS_SHOWCASE_UPLOADED_AT = "2026-10-27T00:00:00+08:00";
